// extracted by mini-css-extract-plugin
export default {"tooltip":"ActionBtn_tooltip__J8fO+","tooltipArrow":"ActionBtn_tooltipArrow__J+Gq+","tooltipContent":"ActionBtn_tooltipContent__60vJy","disabled":"ActionBtn_disabled__IxrsT"};